module.exports = __webpack_public_path__ + "static/media/gigapet-min.c8527b68.png";